import { makeStyles } from '@material-ui/styles';
import {
  dangerColor,
  grayColor,
} from 'assets/jss/material-dashboard-pro-react';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import classNames from 'classnames';

const useStyles = makeStyles({
  formTextInput: {
    alignItems: 'flex-start',
  },
  startAdornment: {
    marginRight: '8px',
    fontSize: '12px',
    fontWeight: '400',
    color: grayColor[20],
    textTransform: 'uppercase',
  },
  startAdornmentError: {
    color: dangerColor[0],
  },
});

const LangFormTextInput = ({ lang, isError, ...formTextInputProps }) => {
  const classes = useStyles();

  return (
    <FormTextInput
      className={classes.formTextInput}
      {...formTextInputProps}
      error={isError}
      startAdornment={
        <span
          className={classNames(
            classes.startAdornment,
            isError && classes.startAdornmentError
          )}
        >
          {lang}
        </span>
      }
    />
  );
};

export default LangFormTextInput;
